module.exports = __webpack_public_path__ + "static/media/text-url.8f158087.png";